// @flow
import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'Client/router/withRouter';
import { convertLocationToURI } from 'Utils/uri/uriUtils';
import { get } from 'lodash';
import { getSpaUrl } from 'Components/frameworks/dynamic-link/DynamicLinkUtil';
import {
  ProductInformationSlider,
  type ProductInformationSliderProps,
} from './ProductInformationSlider';
import { ProductInformationLayer } from './ProductInformationLayer';

type ProductInformationSliderContainerProps = {
  ...ProductInformationSliderProps,
  history: RouterHistory,
  location: RouterLocation<{}, {}>,
  queryLayer: string,
  renderDetail: (data: Object) => Node,
  sliderIndex: number,
};

const _ProductInformationSliderContainer = (props: ProductInformationSliderContainerProps) => {
  // -1 to init activeItem (it means no item has been selected yet), 0 is the index of first element
  const [activeItem, setActiveItem] = useState(-1);
  const { queryLayer, sliderIndex, location } = props;
  const uri = convertLocationToURI(location);
  // -1_-1 is the default value of queryparam to initialise sliderIndex and activeItem (-1)
  const active = get(uri.query(true), queryLayer, '-1_-1');
  const [uriSliderIndex, uriActiveItem] = active.split('_');

  useEffect(
    () => {
      if (uri.hasQuery(queryLayer, /^[0-9]_[0-9]*$/) && Number(uriSliderIndex) === sliderIndex) {
        setActiveItem(uriActiveItem);
      }
    },
    [location],
  );

  const toggleLayer = (item: number, layer: boolean): void => {
    let newUrl = uri.clone();
    if (layer) {
      newUrl = newUrl.addQuery({
        [queryLayer]: `${sliderIndex}_${item}`,
      });
    } else {
      newUrl = newUrl.removeQuery({
        [queryLayer]: `${sliderIndex}_${uriActiveItem}`,
      });
    }
    // using window.history replaceState to add or remove queryParam in silent mode (without triggering component rerender)
    window.history.pushState(null, null, getSpaUrl(newUrl));
    setActiveItem(item);
  };

  return (
    <Fragment>
      <ProductInformationSlider {...props} toggleLayer={toggleLayer} />
      <ProductInformationLayer {...props} activeItem={activeItem} toggleLayer={toggleLayer} />
    </Fragment>
  );
};

export const ProductInformationSliderContainer = withRouter(_ProductInformationSliderContainer);
